import React from "react";
import MonthlyTimeTable from "../MonthlyTimeTable";

const AprilSehriIftaar = ({districtDetails}) => {
  return <MonthlyTimeTable month={4} title="April Sehri Iftar" columnKey="3Columns" districtDetails={districtDetails} />;
};

export default AprilSehriIftaar;
